import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { ParseFormat } from 'app/model/dataflow/parsetransformation';
import { FLOW } from 'app/model/adapters/dataflow/IDataflow';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { ExpressionBasedColumnVisitorAdapterUtils } from '../expression-based-column-visitor-adapter.utils';
import { StringifyTransformation } from 'app/model/dataflow/stringifytransformation';
import { DataFlowExpressionUtils } from '../expression.util';
import { ExpressionBasedColumn } from 'app/model/dataflow/expression-based.column';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(StringifyTransformation),
    asynchronous: true
})
export class StringifyTransformationAdapter extends TransformationAdapter<StringifyTransformation> {
    public async getDslScript(stringifyTransformation: StringifyTransformation): Promise<string> {
        const props: string[] = [];

        for (const col of stringifyTransformation.expressionColumns) {
            const expressionColumn = col as ExpressionBasedColumn;
            expressionColumn.fixedReturnTypeExpression.expression = 'string';
        }

        props.push(
            await ExpressionBasedColumnVisitorAdapterUtils.writeToDsl(
                this.context.contextData,
                stringifyTransformation.expressionColumns,
                stringifyTransformation
            )
        );
        props.push(TransformationAdapter.getPartitionDslScript(stringifyTransformation));
        props.push(`format: '${stringifyTransformation.format}'`);
        switch (stringifyTransformation.format) {
            case ParseFormat.delimitedText:
                props.push(`columnNamesAsHeader: ${stringifyTransformation.delimitedTextSettings.columnNamesAsHeader}`);
                props.push(`columnDelimiter: '${stringifyTransformation.delimitedTextSettings.columnDelimiter}'`);
                props.push(
                    `nullValue: '${DataFlowExpressionUtils.escapeBackslashInDslString(
                        stringifyTransformation.delimitedTextSettings.nullValue
                    )}'`
                );
                break;
            default:
                break;
        }
        const knownProps = props.filter((c) => !!c).join(',\n\t');
        const unknownProps = this._getUnknownProps(stringifyTransformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');

        return (
            `${this._getInputStreams(stringifyTransformation)} ${
                StringifyTransformation.MODEL.name
            }(${transformationData}) ` + `${FLOW} ${this._getOutputStreams(stringifyTransformation)}`
        );
    }
}
